<div class="card">
  <div class="card-body">
    <h5 class="card-title"><i class="fas fa-stethoscope"></i> FlowCheck</h5>

    <div class="input-group mb-3">
      <input
        type="text"
        class="form-control"
        placeholder="FlowID"
        (input)="updateFlowId($event.target.value)"
        [readonly]="isLoading$ | async"
      />
      <div class="input-group-append">
        <button
          class="btn btn-primary"
          [disabled]="!(canCheck$ | async)"
          type="button"
          id="button-addon2"
          (click)="checkFlow()"
        >
          CheckFlow
        </button>
      </div>
    </div>

    <div class="d-flex justify-content-center" *ngIf="isLoading$ | async">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>

    <div *ngIf="checkResult">
      <div class="activity-data">
        <div>
          ID: <span>{{ checkResult.activity.id }}</span>
        </div>
        <div>
          Name: <span>{{ checkResult.activity.name }}</span>
        </div>
        <div>
          Section: <span>{{ checkResult.activity.sectionId }}</span>
        </div>
        <div>
          Status: <span>{{ checkResult.activity.status }}</span>
        </div>
      </div>

      <div
        *ngFor="let check of checkResult.checks"
        class="check"
        [ngClass]="'check-' + check.status"
      >
        <div class="check-name">
          <span class="check-status">{{ check.status }}</span> -
          {{ check.name }}
        </div>
        <div class="check-message">{{ check.message }}</div>
        <pre class="check-meta">{{ check.meta | json }}</pre>
      </div>
    </div>
  </div>
</div>
